import { useEffect, useRef } from 'react';
import { OverlayManager } from './OverlayManager';
export function useOverlay(options) {
    var visible = options.visible, onClose = options.onClose, essentialRefs = options.essentialRefs, _a = options.unsafe_strategy, closeStrategy = _a === void 0 ? 'pressdown' : _a;
    var optionsRef = useRef({ onClose: onClose, refs: essentialRefs, closeStrategy: closeStrategy });
    optionsRef.current.onClose = onClose;
    optionsRef.current.refs = essentialRefs;
    useEffect(function () {
        if (visible) {
            var options_1 = optionsRef.current;
            OverlayManager.addOverlay(options_1);
            return function () {
                OverlayManager.removeOverlay(options_1);
            };
        }
        return;
    }, [visible]);
}
